module.exports = __webpack_public_path__ + "img/banerFlashmobile.ca12d507.jpg";